namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pmg = Portico.Models.Gateway;
	import pme = Portico.Models.Enterprise;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;
	import psge = apigateway.enums;
	import psgm = apigateway.models;

	export class Action {
		command: any;
		messages: string[];
		result: any;
		success: boolean;
		type: string;

		child: Action;
		next: Action;
		parent: Action;
		previous: Action;
		scope: angular.IScope;

		constructor(command: any, type: string) {
			this.command = command;
			this.messages = [];
			this.result = null;
			this.success = true;
			this.type = type;

			this.child = null;
			this.next = null;
			this.parent = null;
			this.previous = null;
			this.scope = null;
		}

		isAllowed(): boolean {
			const allowCommand = this.command !== null;
			const allowIf = this.type !== 'IF' || (this.type === 'IF' && this.result !== false);
			const allowElse = this.type !== 'ELSE' || (this.type === 'ELSE' && this.result !== false);
			const allowError = this.type !== 'ERROR' || (this.type === 'ERROR' && this.result !== false);
			const allowParent = this.parent === null || this.parent.isAllowed();
			const allow = allowCommand && allowIf && allowElse && allowError && allowParent;

			return allow;
		}
	}

	export class ActionProcessor {
		private _action: Action;
		private _promise: angular.IPromise<boolean>;
		private _stopped: boolean;

		constructor(private $q: angular.IQService, private porticoService: ps.IPorticoService) {
			this._action = null;
			this._promise = this.$q.when(true);
			this._stopped = false;
		}

		begin(): ActionProcessor {
			return this._add(() => {
				return null;
			}, 'BEGIN');
		}

		else(): ActionProcessor {
			return this._add((self: Action) => {
				return self.previous && !self.previous.result;
			}, 'ELSE');
		}

		end(): ActionProcessor {
			return this._add(() => {
				return null;
			}, 'END');
		}

		error(): ActionProcessor {
			return this._add((self: Action) => {
				return self.previous && !self.previous.success;
			}, 'ERROR');
		}

		if(expression: string): ActionProcessor {
			return this._add((self: Action) => {
				return !!self.scope.$eval(expression);
			}, 'IF');
		}

		private log(action: Action, depth: number): string {
			let callStack = '';

			for (let i = 0; i < depth; i++) {
				callStack += '\t';
			}

			callStack += action.type + '\n';

			if (action.child) {
				callStack += this.log(action.child, depth + 1);
			}

			if (action.next) {
				callStack += this.log(action.next, depth);
			}

			return callStack;
		}

		promise(): angular.IPromise<boolean> {
			if (this.porticoService.dataService.session.mode === 'edit') {
				this.porticoService.$log.info('ActionService Call Stack:\n' + this.log(this._action, 1));
			}

			return this._promise;
		}

		result(target: string, messages: string = null): ActionProcessor {
			return this._add((self: Action) => {
				self.scope.$eval(`${target}=v`, { v: self.parent.result });

				if (messages) {
					self.scope.$eval(`${messages}=v`, { v: self.parent.messages });
				}
			}, 'RESULT');
		}

		scope($scope: angular.IScope): ActionProcessor {
			return this._add(() => {
				return null;
			}, 'SCOPE', $scope);
		}

		stop(): ActionProcessor {
			return this._add(() => {
				this._stopped = true;
				return null;
			}, 'STOP');
		}

		private _add(command: any, type: string = 'COMMAND', $scope: angular.IScope = null): ActionProcessor {
			const action = new Action(command, type);

			if (this._action == null) {
				this._action = action;
			} else {
				let last = this._last(this._action, action.type);

				if (this.porticoService.dataService.session.mode === 'edit') {
					this.porticoService.$log.info('ActionService: { action = ' + type + ', last = ' + last.type + '}');
				}

				//if (['RESULT'].includes(action.type)) {
				if (_.indexOf(['RESULT'], action.type) > -1) {
					action.parent = last;
					last.child = action;
				}
				//else if (['BEGIN', 'ELSE', 'ERROR', 'IF'].includes(last.type) && !last.child) {
				else if (_.indexOf(['BEGIN', 'ELSE', 'ERROR', 'IF'], last.type) > -1 && !last.child) {

					action.parent = last;
					last.child = action;
				} else {
					action.previous = last;
					action.parent = last.parent;
					last.next = action;
				}
			}

			action.scope = ($scope ? $scope : (action.previous ? action.previous.scope : (action.parent ? action.parent.scope : null)));

			this._execute(action);

			return this;
		}

		private _execute(action: Action) {
			if (!this._stopped) {
				this._promise = this._promise.then((result) => {
					const response = action.isAllowed() ? action.command(/* self = */ action) : null;
					const promise = this.$q.when(response);

					return promise.then((result) => {
						action.result = result;
						action.success = true;
						return true;
					}).catch((messages) => {
						action.messages = messages;
						action.success = false;
						return true;
					});
				});
			}
		}

		private _last(action: Action, type: string): Action {
			if (action.next) {
				const temp = this._last(action.next, type);

				//if (temp) {
				return temp;
				//}
			}

			//if (['BEGIN', 'ELSE', 'ERROR', 'IF'].includes(action.type)) {
			if (_.indexOf(['BEGIN', 'ELSE', 'ERROR', 'IF'], action.type) > -1) {
				if (!action.child) {
					return action;
				}

				const temp = this._last(action.child, type);

				if (temp) {
					return temp;
				}
			}

			if (action.parent) {
				//if (['ELSE'].includes(type) && ['ERROR', 'IF'].includes(action.type)) {
				if (_.indexOf(['ELSE'], type) > -1 && _.indexOf(['ERROR', 'IF'], action.type) > -1) {
					return action;
				}

				//if (['END'].includes(action.type) && ['BEGIN'].includes(action.parent.type)) {
				if (_.indexOf(['END'], type) > -1 && _.indexOf(['BEGIN'], action.parent.type) > -1) {
					return action.parent;
				}

				//if (['ELSE', 'ERROR', 'IF'].includes(action.parent.type)) {
				if (_.indexOf(['ELSE', 'ERROR', 'IF'], action.parent.type) > -1) {
					return null;
				}
			}

			return action;
		}

		///////////////////////////////////
		// data initialization functions //
		///////////////////////////////////

		/** @deprecated */
		initDataTables(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initDataTables();
			}, 'initDataTables');
		}

		/** @deprecated */
		initDataTypes(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initDataTypes();
			}, 'initDataTypes');
		}

		/** @deprecated */
		initDemos(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initDemos();
			}, 'initDemos');
		}

		/** @deprecated */
		initDiagnoses(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initDiagnoses();
			}, 'initDiagnoses');
		}

		/** @deprecated */
		initIntakeLayout(key: string = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initIntakeLayout(key);
			}, 'initIntakeLayout');
		}

		/** @deprecated */
		initLayoutSection(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initLayoutSection();
			}, 'initLayoutSection');
		}

		/** @deprecated */
		initNdcs(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initNdcs();
			}, 'initNdcs');
		}

		/** @deprecated */
		initPortal(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initPortal();
			}, 'initPortal');
		}

		/** @deprecated */
		initStates(key: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initStates(key);
			}, 'initStates');
		}

		/** @deprecated */
		initSurveys(key: string = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initSurveys(key);
			}, 'initSurveys');
		}

		/** @deprecated */
		initTemplates(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.initTemplates();
			}, 'initTemplates');
		}

		/////////////////////////////////
		// demo portal setup functions //
		/////////////////////////////////

		editPortal(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.demoService.edit(id);
			}, 'editPortal');
		}

		removePortal(portal: pms.Portal): ActionProcessor {
			return this._add(() => {
				return this.porticoService.demoService.remove(portal);
			}, 'removePortal');
		}

		savePortal(demo: pms.Demo): ActionProcessor {
			return this._add(() => {
				return this.porticoService.demoService.save(demo);
			}, 'savePortal');
		}

		///////////////////////
		// account functions //
		///////////////////////

		account_create(account: pme.Account = null) {
			return this._add(() => {
				const programId = this.porticoService.dataService.getProgramId();
				return this.porticoService.enterpriseService.accountService.create(programId, account);
			}, 'account_create');
		}

		account_createFromCase(caze: psgm.GetCaseResponseModel) {
			return this._add(() => {
				const programId = this.porticoService.dataService.getProgramId();
				return this.porticoService.enterpriseService.accountService.createFromCase(programId, caze);
			}, 'account_createFromCase');
		}

		account_getPrescribers(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.getPrescribers();
			}, 'account_getPrescribers');
		}

		account_getSites(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.getSites();
			}, 'account_getSites');
		}

		account_getTasks(typeId: number, accountId: number = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.getTasks(typeId, accountId);
			}, 'account_getTasks');
		}

		// placeholder for action to populate the account with all data...
		account_populate(account: pme.Account): ActionProcessor {
			return this._add(() => {
				return null;
			}, 'account_populate');
		}

		account_savePrescriber(prescriber: pme.Prescriber): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.savePrescriber(prescriber);
			}, 'account_savePrescriber');
		}

		account_saveSite(site: pme.Site): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.saveSite(site);
			}, 'account_saveSite');
		}

		account_saveTask(task: pme.Task): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.saveTask(task);
			}, 'account_saveTask');
		}

		account_diagnosis_populate(account: pme.Account): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.diagnosisService.populate(account);
			}, 'account_diagnosis_populate');
		}

		account_payor_add(account: pme.Account, role: psge.PayorType, index: number = null): ActionProcessor {
			return this._add(() => {
				return account.addPayor(role, index);
			}, 'account_payor_add');
		}

		account_payor_filter(account: pme.Account, role: psge.PayorType): ActionProcessor {
			return this._add(() => {
				return account.filterPayors(role);
			}, 'account_payor_filter');
		}

		account_payor_length(account: pme.Account, role: psge.PayorType): ActionProcessor {
			return this._add(() => {
				return account.filterPayors(role).length;
			}, 'account_payor_length');
		}

		account_payor_populate(account: pme.Account): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.payorService.populate(account);
			}, 'account_payor_populate');
		}

		account_payor_remove(account: pme.Account, relationship: pme.PayorRelationship): ActionProcessor {
			return this._add(() => {
				return account.removePayor(relationship);
			}, 'account_payor_remove');
		}

		account_pharmacy_populate(account: pme.Account): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.pharmacyService.populate(account);
			}, 'account_pharmacy_populate');
		}

		account_prescriber_add(account: pme.Account): ActionProcessor {
			return this._add(() => {
				return account.addPrescriber();
			}, 'account_prescriber_add');
		}

		account_prescriber_length(account: pme.Account): ActionProcessor {
			return this._add(() => {
				return account.prescriberRelationships.length;
			}, 'account_prescriber_length');
		}

		account_prescriber_populate(account: pme.Account): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.prescriberService.populate(account);
			}, 'account_prescriber_populate');
		}

		account_prescriber_remove(account: pme.Account, relationship: pme.PrescriberRelationship): ActionProcessor {
			return this._add(() => {
				return account.removePrescriber(relationship);
			}, 'account_prescriber_remove');
		}

		account_prescription_populate(account: pme.Account): ActionProcessor {
			return this._add(() => {
				const programId = this.porticoService.dataService.getProgramId();
				return this.porticoService.enterpriseService.prescriptionService.populate(programId, account);
			}, 'account_prescription_populate');
		}

		account_surveySession_populate(account: pme.Account, surveyIds: number[]): ActionProcessor {
			return this._add(() => {
				const programId = this.porticoService.dataService.getProgramId();
				return this.porticoService.enterpriseService.surveyService.populate_session(programId, account, surveyIds);
			}, 'account_surveySession_populate');
		}

		account_surveySession_answer_get(account: pme.Account, survey: number | string, question: number | string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.account_surveySession_answer_get(account, survey, question);
			}, 'account_surveySession_answer_get');
		}

		account_surveySession_answer_getValue(account: pme.Account, survey: number | string, question: number | string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.account_surveySession_answer_getValue(account, survey, question);
			}, 'account_surveySession_answer_getValue');
		}

		account_surveySession_answers_get(account: pme.Account, survey: number | string, question: number | string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.account_surveySession_answers_get(account, survey, question);
			}, 'account_surveySession_answers_get');
		}

		account_surveySession_answers_getValues(account: pme.Account, survey: number | string, question: number | string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.account_surveySession_answers_getValues(account, survey, question);
			}, 'account_surveySession_answers_getValues');
		}

		account_surveySession_answers_set(account: pme.Account, survey: number | string, question: number | string, answers: (number | string)[], value: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.account_surveySession_answers_set(account, survey, question, answers, value);
			}, 'account_surveySession_answers_set');
		}

		account_surveySession_answers_test(account: pme.Account, survey: number | string, question: number | string, answer: number | string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.account_surveySession_answers_test(account, survey, question, answer);
			}, 'account_surveySession_answers_test');
		}

		account_user_activate(userName: string, activate: boolean): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.activateUser(userName, activate);
			}, 'account_user_activate');
		}

		account_user_get(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.getUsers();
			}, 'account_user_get');
		}

		account_user_save(user: pme.User): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.saveUser(user);
			}, 'account_user_save');
		}

		account_userRole_save(userName: string, role: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.saveUserRole(userName, role);
			}, 'account_userRole_save');
		}

		//////////////////////////////
		// authentication functions //
		//////////////////////////////

		authentication_authenticateAccount(userName: string, password: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.authenticateAccount(userName, password);
			}, 'authentication_authenticateAccount');
		}

		authentication_authenticateUser(userName: string, password: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.authenticateUser(userName, password);
			}, 'authentication_authenticateUser');
		}

		authentication_changePassword(oldPassword: string, newPassword: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.changePassword(oldPassword, newPassword);
			}, 'authentication_changePassword');
		}

		authentication_createSession(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.createSession();
			}, 'authentication_createSession');
		}

		authentication_getCurrentUser(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.getCurrentUser();
			}, 'authentication_getCurrentUser');
		}

		authentication_getPortalRoles(portalId: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.getPortalRoles(portalId);
			}, 'authentication_getPortalRoles');
		}

		authentication_getPortalUsers(portalId: number, accountId?: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.getPortalUsers(portalId, accountId);
			}, 'authentication_getPortalUsers');
		}

		authentication_isEmailRegistered(email: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.isEmailRegistered(email);
			}, 'authentication_isEmailRegistered');
		}

		authentication_isExistingUser(userName: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.isExistingUser(userName);
			}, 'authentication_isExistingUser');
		}

		authentication_resetPassword(userName: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.resetPassword(userName);
			}, 'authentication_resetPassword');
		}

		authentication_resetUserPassword(portalId: string, userId: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.resetUserPassword(portalId, userId);
			}, 'authentication_resetUserPassword');
		}

		authentication_saveCurrentUser(user: pme.User): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.saveCurrentUser(user);
			}, 'authentication_saveCurrentUser');
		}

		authentication_saveUser(portalId: string, user: pme.User): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.saveUser(portalId, user);
			}, 'authentication_saveUser');
		}

		authentication_touchSession(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.touchSession();
			}, 'authentication_touchSession');
		}

		authentication_isAuthenticated(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.isAuthenticated();
			}, 'authentication_isAuthenticated');
		}

		authentication_logOut(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.logOut();
			}, 'authentication_logOut');
		}

		/////////////////////////////
		// authorization functions //
		/////////////////////////////		

		authorization_userProfile_get(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authorizationService.getUserProfile(id);
			}, 'authorization_userProfile_get');
		}

		/////////////////////////////
		// case/workflow functions //
		/////////////////////////////		

		/////////////////////////////////
		// data manipulation functions //
		/////////////////////////////////

		copy(source: any, target: any = null): ActionProcessor {
			return this._add(() => {
				return target ? angular.copy(source, target) : angular.copy(source);
			}, 'copy');
		}

		eval(expression: string): ActionProcessor {
			return this._add((self: Action) => {
				return self.scope.$eval(expression);
			}, 'eval');
		}

		/////////////////////
		// claim functions //
		/////////////////////

		claim_getAccumulator(memberNumber: string, date: Date): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.claimService.getAccumulator(memberNumber, date);
			}, 'claim_getAccumulator');
		}

		//////////////////////////
		// conversion functions //
		//////////////////////////

		conversion_getCaseResponseModelToAccount(model: psgm.GetCaseResponseModel): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.conversionService.convertGetCaseResponseModelToAccount(model);
			}, 'conversion_getCaseResponseModelToAccount');
		}

		/////////////////////////
		// diagnosis functions //
		/////////////////////////

		diagnosis_get(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.diagnosisService.getByProgramId();
			}, 'diagnosis_get');
		}

		////////////////////////
		// document functions //
		////////////////////////

		document_createPdfFromAccount(account: pme.Account): ActionProcessor {
			return this._add(() => {
				return this.porticoService.document_createPdfFromAccount(account);
			}, 'document_createPdfFromAccount');
		}

		document_upload(file: any, typeId: number = 10002): ActionProcessor {
			return this._add(() => {
				const programId = this.porticoService.dataService.getProgramId();
				return this.porticoService.enterpriseService.documentService.upload(programId, typeId, file);
			}, 'document_upload');
		}

		////////////////////////////////
		// dom manipulation functions //
		////////////////////////////////

		color(hex: string, percent: number = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.color(hex, percent || 0);
			}, 'color');
		}

		element_show(id: string, show: boolean): ActionProcessor {
			return this._add(() => {
				return this.porticoService.elementShow(id, show);
			}, 'element_show');
		}

		/////////////////////
		// email functions //
		/////////////////////

		email_feedback(feedbackRequest: pme.FeedbackRequest): ActionProcessor {
			return this._add(() => {
				return this.porticoService.email_feedback(feedbackRequest);
			}, 'email_feedback');
		}

		email_isUnsubscribed(email: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.emailService.isUnsubscribed(email);
			}, 'email_isUnsubscribed');
		}

		email_send(emailRequest: pme.EmailRequest, checkUnsubscribe: boolean = true): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.emailService.send(emailRequest, checkUnsubscribe);
			}, 'email_send');
		}

		email_unsubscribe(accountId: number, email: string, userId: number, username: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.emailService.unsubscribe(accountId, email, userId, username);
			}, 'email_unsubscribe');
		}

		//////////////////////////
		// enrollment functions //
		//////////////////////////

		enrollment_create(enrollment: pme.Enrollment = null) {
			return this._add(() => {
				return this.porticoService.enterpriseService.enrollmentService.create(enrollment);
			}, 'enrollment_create');
		}

		///////////////////
		// hub functions //
		///////////////////

		hub_account_get(accountId: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.hubService.getAccount(accountId);
			}, 'hub_account_get');
		}

		hub_account_search(patient: pme.Patient): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.hubService.searchAccounts(patient);
			}, 'hub_account_search');
		}

		hub_patient_get(patientId: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.hubService.getPatient(patientId);
			}, 'hub_patient_get');
		}

		hub_patient_save(patient: pme.Patient): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.hubService.savePatient(patient);
			}, 'hub_patient_save');
		}

		hub_patient_search(patient: pme.Patient): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.hubService.searchPatients(patient);
			}, 'hub_patient_search');
		}

		////////////////////////////
		// intakeLayout functions //
		////////////////////////////

		intakeLayout_survey_populate(intakeLayout: pme.IntakeLayout): ActionProcessor {
			return this._add(() => {
				return this.porticoService.intakeLayout_survey_populate(intakeLayout);
			}, 'intakeLayout_survey_populate');
		}

		//////////////////////
		// legacy functions //
		//////////////////////

		legacy_survey_checkAnswer(question: number | string, account: pme.Account): ActionProcessor {
			return this._add(() => {
				const questionId = this.porticoService.dataService.getEnvironmentId(question);
				const survey = this.porticoService.dataService.enterprise.intakeLayout.getSurveyByQuestionId(questionId);
				const surveyId = this.porticoService.dataService.getEnvironmentId(survey.surveyId);

				return this.porticoService.legacyService.checkAnswer(surveyId, questionId, account);
			}, 'legacy_survey_checkAnswer');
		}

		legacy_survey_checkAnswers(questions: (number | string)[], account: pme.Account): ActionProcessor {
			return this._add(() => {
				const questionIds = questions.map((question) => {
					return this.porticoService.dataService.getEnvironmentId(question);
				});

				const surveyIds = questionIds.map((questionId) => {
					const survey = this.porticoService.dataService.enterprise.intakeLayout.getSurveyByQuestionId(questionId);
					return this.porticoService.dataService.getEnvironmentId(survey.surveyId);
				});

				return this.porticoService.legacyService.checkAnswers(surveyIds, questionIds, account);
			}, 'legacy_survey_checkAnswers');
		}

		legacy_basicEnrollment(account: pme.Account, enrollment: pme.Enrollment): ActionProcessor {
			return this._add(() => {
				return this.porticoService.legacyService.enroll(account, enrollment);
			}, 'legacy_basicEnrollment');
		}

		legacy_checkMemberNumber(memberNumber: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.legacyService.checkMN(memberNumber);
			}, 'legacy_checkMemberNumber');
		}

		/////////////////////
		// modal functions //
		/////////////////////

		modal_hide(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.modalService.hide(id);
			}, 'modal_hide');
		}

		modal_hide_2(key: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.modalService.hide2(key);
			}, 'modal_hide_2');
		}

		modal_show(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.modalService.show(id);
			}, 'modal_show');
		}

		modal_show_2(key: string, clazz: string, init: string): ActionProcessor {
			return this._add((self: Action) => {
				return this.porticoService.modalService.show2(self.scope, key, clazz, init);
			}, 'modal_show_2');
		}

		/////////////////////////
		// note/task functions //
		/////////////////////////

		///////////////////////
		// patient functions //
		///////////////////////

		patient_get(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.patientService.get(id);
			}, 'patient_get');
		}

		patient_search(search: pme.Patient): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.patientService.search(search);
			}, 'patient_search');
		}

		///////////////////////////////
		// patient account functions //
		///////////////////////////////

		patientAccount_getAccount(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.patientAccountService.getAccount();
			}, 'patientAccount_getAccount');
		}

		patientAccount_getCase(caseId: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.patientAccountService.getCase(caseId);
			}, 'patientAccount_getCase');
		}

		patientAccount_isPatientRegistered(registration: pme.PatientAccountRegistration): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.patientAccountService.isPatientRegistered(registration);
			}, 'patientAccount_isPatientRegistered');
		}

		patientAccount_patientRegistration(registration: pme.PatientAccountRegistration): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.patientAccountService.patientRegistration(registration);
			}, 'patientAccount_patientRegistration');
		}

		/////////////////////
		// payor functions //
		/////////////////////

		payor_get(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.payorService.get(id);
			}, 'payor_get');
		}

		payor_search(search: pme.Payor, stateCoverageArea: string, max: number = 30, local: boolean = false, global: boolean = true): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.payorService.search(search, stateCoverageArea, max, local, global);
			}, 'payor_search');
		}

		/////////////////////////////
		// payor benefit functions //
		/////////////////////////////

		payor_benefit_get(accountId: number, payorId: number, role: psge.PayorType): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.payorService.getPayorBenefit(accountId, payorId, role);
			}, 'payor_benefit_get');
		}

		////////////////////////
		// pharmacy functions //
		////////////////////////

		pharmacy_get(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.pharmacyService.get(id);
			}, 'pharmacy_get');
		}

		pharmacy_search(search: pme.Pharmacy): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.pharmacyService.search(search);
			}, 'pharmacy_search');
		}

		//////////////////////////
		// prescriber functions //
		//////////////////////////

		prescriber_create(addresses: number = 0, emailAddresses: number = 0, externalIds: number = 0, phoneNumbers: number = 0, prescriberLicenses: number = 0): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.prescriberService.create(addresses, emailAddresses, externalIds, phoneNumbers, prescriberLicenses);
			}, 'prescriber_create');
		}

		prescriber_get(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.prescriberService.get(id);
			}, 'prescriber_get');
		}

		prescriber_remove(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.removePrescriber(id);
			}, 'prescriber_remove');
		}

		prescriber_search(search: pme.Prescriber): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.prescriberService.search(search);
			}, 'prescriber_search');
		}

		////////////////////////////
		// prescription functions //
		////////////////////////////

		prescription_getByAccountId(id: number): ActionProcessor {
			return this._add(() => {
				const programId = this.porticoService.dataService.getProgramId();
				return this.porticoService.enterpriseService.prescriptionService.getByAccountId(programId, id);
			}, 'prescription_getByAccountId');
		}

		prescription_ndc_list(): ActionProcessor {
			return this._add(() => {
				const programId = this.porticoService.dataService.getProgramId();
				return this.porticoService.enterpriseService.prescriptionService.getNdcList(programId);
			}, 'prescription_ndc_list');
		}

		///////////////////////
		// program functions //
		///////////////////////

		program_id(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.dataService.getProgramId();
			}, 'program_id');
		}

		///////////////////////
		// session functions //
		///////////////////////

		getExistingPortalSession(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.sessionService.getExistingSession();
			}, 'getExistingPortalSession');
		}

		session_touch(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.touchSession();
			}, 'session_touch');
		}

		session_application_get(name: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.sessionService.getApplication(name);
			}, 'session_application_get');
		}

		session_application_save(application: pme.Application): ActionProcessor {
			return this._add(() => {
				return this.porticoService.sessionService.saveApplication(application);
			}, 'session_application_save');
		}

		/////////////////////
		// setup functions //
		/////////////////////

		setup_dataColumn_add(dataTable: pms.DataTable, dataColumn: pms.DataColumn): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.addDataColumn(dataTable, dataColumn);
			}, 'setup_dataColumn_add');
		}

		setup_dataColumn_remove(dataTable: pms.DataTable, dataColumn: pms.DataColumn): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removeDataColumn(dataTable, dataColumn);
			}, 'setup_dataColumn_remove');
		}

		setup_dataGroup_get(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataGroupTypeService.get().then((dataGroupTypes) => {
					const promises = {};

					dataGroupTypes = dataGroupTypes.sort((a, b) => {
						return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
					});

					dataGroupTypes.forEach((dataGroupType) => {
						promises[dataGroupType.id] = this.porticoService.setupService.dataGroupService.getByDataGroupTypeId(dataGroupType.id);
					});

					return this.$q.all(promises).then((results) => {
						let dataGroups = [];

						dataGroupTypes.forEach((dataGroupType) => {
							const temp = results[dataGroupType.id].sort((a, b) => {
								return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
							});

							temp.forEach((dataGroup) => {
								dataGroup.dataGroupType = dataGroupType;
							});

							dataGroups = dataGroups.concat(temp);
						});

						return dataGroups;
					});
				});
			}, 'setup_dataGroup_get');
		}

		setup_dataGroup_getByDataGroupTypeId(dataGroupTypeId: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataGroupService.getByDataGroupTypeId(dataGroupTypeId);
			}, 'setup_dataGroup_getByDataGroupTypeId');
		}

		setup_dataGroup_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataGroupService.getHistory(id);
			}, 'setup_dataGroup_getHistory');
		}

		setup_dataGroup_new(dataGroupTypeId: string, dataGroup: pms.DataGroup = null): ActionProcessor {
			return this._add(() => {
				return dataGroup ? this.$q.when(new pms.DataGroup(dataGroup)) : this.$q.when(new pms.DataGroup(<pms.IDataGroup>{ dataGroupTypeId: dataGroupTypeId }))
			}, 'setup_dataGroup_new');
		}

		setup_dataGroup_remove(dataGroup: pms.DataGroup, dataGroups: pms.DataGroup[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removeDataGroup(dataGroup, dataGroups);
			}, 'setup_dataGroup_remove');
		}

		setup_dataGroup_save(dataGroup: pms.DataGroup, dataGroups: pms.DataGroup[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.saveDataGroup(dataGroup, dataGroups);
			}, 'setup_dataGroup_save');
		}

		setup_dataGroupType_get(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataGroupTypeService.get();
			}, 'setup_dataGroupType_get');
		}

		setup_dataGroupType_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataGroupTypeService.getHistory(id);
			}, 'setup_dataGroupType_getHistory');
		}

		setup_dataGroupType_new(dataGroupType: pms.DataGroupType): ActionProcessor {
			return this._add(() => {
				return dataGroupType ? this.$q.when(new pms.DataGroupType(dataGroupType)) : this.$q.when(new pms.DataGroupType());
			}, 'setup_dataGroupType_new');
		}

		setup_dataGroupType_remove(dataGroupType: pms.DataGroupType, dataGroupTypes: pms.DataGroupType[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removeDataGroupType(dataGroupType, dataGroupTypes);
			}, 'setup_dataGroupType_remove');
		}

		setup_dataGroupType_save(dataGroupType: pms.DataGroupType, dataGroupTypes: pms.DataGroupType[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.saveDataGroupType(dataGroupType, dataGroupTypes);
			}, 'setup_dataGroupType_save');
		}

		setup_dataRow_getByDataGroupId(dataGroupId: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataRowService.getByDataGroupId(dataGroupId);
			}, 'setup_dataRow_getByDataGroupId');
		}

		setup_dataRow_getConflict(dataRow: pms.DataRow): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataRowService.getConflict(dataRow);
			}, 'setup_dataRow_getConflict');
		}

		setup_dataRow_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataRowService.getHistory(id);
			}, 'setup_dataRow_getHistory');
		}

		setup_dataRow_fix(dataTable: pms.DataTable, dataRow: pms.DataRow): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.fixDataRow(dataTable, dataRow);
			}, 'setup_dataRow_fix');
		}

		setup_dataRow_new(dataGroupId: string, dataTableId: string, dataRow: pms.DataRow = null): ActionProcessor {
			return this._add(() => {
				return dataRow ? this.$q.when(new pms.DataRow(dataRow)) : this.$q.when(new pms.DataRow(<pms.IDataRow>{ dataGroupId: dataGroupId, dataTableId: dataTableId }));
			}, 'setup_dataRow_new');
		}

		setup_dataRow_remove(dataRow: pms.DataRow, dataRows: pms.DataRow[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removeDataRow(dataRow, dataRows);
			}, 'setup_dataRow_remove');
		}

		setup_dataRow_save(dataRow: pms.DataRow, dataRows: pms.DataRow[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.saveDataRow(dataRow, dataRows);
			}, 'setup_dataRow_save');
		}

		setup_dataTable_get(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataTableService.get();
			}, 'setup_dataTable_get');
		}

		setup_dataTable_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataTableService.getHistory(id);
			}, 'setup_dataTable_getHistory');
		}

		setup_dataTable_new(dataTable: pms.DataTable = null): ActionProcessor {
			return this._add(() => {
				return dataTable ? this.$q.when(new pms.DataTable(dataTable)) : this.$q.when(new pms.DataTable());
			}, 'setup_dataTable_new');
		}

		setup_dataTable_remove(dataTable: pms.DataTable, dataTables: pms.DataTable[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removeDataTable(dataTable, dataTables);
			}, 'setup_dataTable_remove');
		}

		setup_dataTable_save(dataTable: pms.DataTable, dataTables: pms.DataTable[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.saveDataTable(dataTable, dataTables);
			}, 'setup_dataTable_save');
		}

		setup_dataType_get(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataTypeService.get();
			}, 'setup_dataType_get');
		}

		setup_dataType_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.dataTypeService.getHistory(id);
			}, 'setup_dataType_getHistory');
		}

		setup_portal_get(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalGroupService.get().then((portalGroups) => {
					const promises = {};

					portalGroups = portalGroups.sort((a, b) => {
						return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
					});

					portalGroups.forEach((portalGroup) => {
						promises[portalGroup.id] = this.porticoService.setupService.portalService.getByPortalGroupId(portalGroup.id);
					});

					return this.$q.all(promises).then((results) => {
						let portals = [];

						portalGroups.forEach((portalGroup) => {
							const temp = results[portalGroup.id].sort((a, b) => {
								return a.name < b.name ? -1 : (a.name > b.name ? 1 : 0);
							});

							temp.forEach((portal) => {
								portal.portalGroup = portalGroup;
							});

							portals = portals.concat(temp);
						});

						return portals;
					});
				});
			}, 'setup_portal_get');
		}

		setup_portal_getById(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalService.getById(id);
			}, 'setup_portal_getById');
		}

		setup_portal_getByPortalGroupId(portalGroupId: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalService.getByPortalGroupId(portalGroupId);
			}, 'setup_portal_getByPortalGroupId');
		}

		setup_portal_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalService.getHistory(id);
			}, 'setup_portal_getHistory');
		}

		setup_portal_import(upload: any): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.importPortal(upload);
			}, 'setup_portal_import');
		}

		setup_portal_new(portalGroupId: string, portal: pms.Portal = null): ActionProcessor {
			return this._add(() => {
				return portal ? this.$q.when(new pms.Portal(portal)) : this.$q.when(new pms.Portal(<pms.IPortal>{ portalGroupId: portalGroupId }));
			}, 'setup_portal_new');
		}

		setup_portal_remove(portal: pms.Portal, portals: pms.Portal[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removePortal(portal, portals);
			}, 'setup_portal_remove');
		}

		setup_portal_save(portal: pms.Portal, portals: pms.Portal[], copyFrom: string = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.savePortal(portal, portals, copyFrom);
			}, 'setup_portal_save');
		}

		setup_portalChild_getByPortalId(portalId: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalChildService.getByPortalId(portalId);
			}, 'setup_portalChild_getByPortalId');
		}

		setup_portalChild_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalChildService.getHistory(id);
			}, 'setup_portalChild_getHistory');
		}

		setup_portalChild_new(portalId: string, portalChild: pms.PortalChild = null): ActionProcessor {
			return this._add(() => {
				return portalChild ? this.$q.when(new pms.PortalChild(portalChild)) : this.$q.when(new pms.PortalChild(<pms.IPortalChild>{ portalId: portalId }));
			}, 'setup_portalChild_new');
		}

		setup_portalChild_remove(portalChild: pms.PortalChild, portalChildren: pms.PortalChild[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removePortalChild(portalChild, portalChildren);
			}, 'setup_portalChild_remove');
		}

		setup_portalChild_save(portalChild: pms.PortalChild, portalChildren: pms.PortalChild[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.savePortalChild(portalChild, portalChildren);
			}, 'setup_portalChild_save');
		}

		setup_portalDataGroup_flatten(portalDataGroups: pms.PortalDataGroup[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.flattenPortalDataGroups(portalDataGroups);
			}, 'setup_portalDataGroup_flatten');
		}

		setup_portalDataGroup_getByPortalId(portalId: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalDataGroupService.getByPortalId(portalId);
			}, 'setup_portalDataGroup_getByPortalId');
		}

		setup_portalDataGroup_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalDataGroupService.getHistory(id);
			}, 'setup_portalDataGroup_getHistory');
		}

		setup_portalDataGroup_new(portalId: string, portalDataGroup: pms.PortalDataGroup = null): ActionProcessor {
			return this._add(() => {
				return portalDataGroup ? this.$q.when(new pms.PortalDataGroup(portalDataGroup)) : this.$q.when(new pms.PortalDataGroup(<pms.IPortalDataGroup>{ portalId: portalId }));
			}, 'setup_portalDataGroup_new');
		}

		setup_portalDataGroup_remove(portalDataGroup: pms.PortalDataGroup, portalDataGroups: pms.PortalDataGroup[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removePortalDataGroup(portalDataGroup, portalDataGroups);
			}, 'setup_portalDataGroup_remove');
		}

		setup_portalDataGroup_save(portalDataGroup: pms.PortalDataGroup, portalDataGroups: pms.PortalDataGroup[], dataGroups: pms.DataGroup[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.savePortalDataGroup(portalDataGroup, portalDataGroups, dataGroups);
			}, 'setup_portalDataGroup_save');
		}

		setup_portalGroup_get(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalGroupService.get();
			}, 'setup_portalGroup_get');
		}

		setup_portalGroup_getById(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalGroupService.getById(id);
			}, 'setup_portalGroup_getById');
		}

		setup_portalGroup_getHistory(id: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.portalGroupService.getHistory(id);
			}, 'setup_portalGroup_getHistory');
		}

		setup_portalGroup_new(portalGroup: pms.PortalGroup = null): ActionProcessor {
			return this._add(() => {
				return portalGroup ? this.$q.when(new pms.PortalGroup(portalGroup)) : this.$q.when(new pms.PortalGroup());
			}, 'setup_portalGroup_new');
		}

		setup_portalGroup_remove(portalGroup: pms.PortalGroup, portalGroups: pms.PortalGroup[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.removePortalGroup(portalGroup, portalGroups);
			}, 'setup_portalGroup_remove');
		}

		setup_portalGroup_save(portalGroup: pms.PortalGroup, portalGroups: pms.PortalGroup[]): ActionProcessor {
			return this._add(() => {
				return this.porticoService.setupService.savePortalGroup(portalGroup, portalGroups);
			}, 'setup_portalGroup_save');
		}

		////////////////////
		// site functions //
		////////////////////

		site_create(addresses: number = 0, contacts: number = 0, emailAddresses: number = 0, externalIds: number = 0, phoneNumbers: number = 0): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteService.create(addresses, emailAddresses, contacts, externalIds, phoneNumbers);
			}, 'site_create');
		}

		site_get(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteService.get(id);
			}, 'site_get');
		}

		site_getByPrescriberId(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteService.getByPrescriberId(id);
			}, 'site_getByPrescriberId');
		}

		site_remove(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.accountService.removeSite(id);
			}, 'site_remove');
		}

		site_search(search: pme.Site): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteService.search(search);
			}, 'site_search');
		}

		////////////////////////////
		// site account functions //
		////////////////////////////

		siteAccount_getAccount(id: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteAccountService.getAccount(id);
			}, 'account_get');
		}

		siteAccount_getCase(caseId: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteAccountService.getCase(caseId);
			}, 'siteAccount_getCase');
		}

		siteAccount_getCases(accountId: number): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteAccountService.getCases(accountId);
			}, 'siteAccount_getCases');
		}

		siteAccount_getParty(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteAccountService.getParty();
			}, 'siteAccount_getPartySite');
		}

		siteAccount_getSiteAccount(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteAccountService.getSiteAccount();
			}, 'siteAccount_getSiteAccount');
		}

		siteAccount_getSiteAccounts(portalId: string): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteAccountService.getSiteAccounts(portalId);
			}, 'siteAccount_getSiteAccounts');
		}

		siteAccount_getWorkflows(accountId: number, includePayors: boolean, includePharmacies: boolean, includePrescribers: boolean): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteAccountService.getWorkflows(accountId, includePayors, includePharmacies, includePrescribers);
			}, 'siteAccount_getWorkflows');
		}

		siteAccount_searchAccounts(search: pme.Account): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.siteAccountService.searchAccounts(search);
			}, 'siteAccount_searchAccounts');
		}

		siteAccount_searchCases(daysInPastBegin: number, daysInPastEnd: number, searchByCreatedDate: boolean, workflowTypes: string[], statusTypes: string[], includePayors: boolean, includePharmacies: boolean, includePrescribers: boolean): ActionProcessor {
			return this._add(() => {
				const date = new Date();
				const after = new Date(date.getTime() - (daysInPastBegin * 24 * 60 * 60 * 1000));
				const before = new Date(date.getTime() - (daysInPastEnd * 24 * 60 * 60 * 1000));
				let searchModel = {
					createdBefore: null,
					createdAfter: null,
					endBefore: null,
					endAfter: null,
					workflowTypes: workflowTypes,
					statusTypes: statusTypes,
					includePayors,
					includePharmacies,
					includePrescribers
				};
				const searchBy = searchByCreatedDate ? 'created' : 'end';
				searchModel[`${searchBy}Before`] = before;
				searchModel[`${searchBy}After`] = after;
				return this.porticoService.enterpriseService.siteAccountService.searchCases(searchModel);
			}, 'siteAccount_searchCases');
		}

		siteAccount_searchWorkflows(daysInPastBegin: number, daysInPastEnd: number, searchByCreatedDate: boolean, workflowTypes: string[], statusTypes: string[], includePayors: boolean, includePharmacies: boolean, includePrescribers: boolean): ActionProcessor {
			return this._add(() => {
				const date = new Date();
				const after = new Date(date.getTime() - (daysInPastBegin * 24 * 60 * 60 * 1000));
				const before = new Date(date.getTime() - (daysInPastEnd * 24 * 60 * 60 * 1000));
				let searchModel = {
					createdBefore: null,
					createdAfter: null,
					endBefore: null,
					endAfter: null,
					workflowTypes: workflowTypes,
					statusTypes: statusTypes,
					includePayors,
					includePharmacies,
					includePrescribers
				};
				const searchBy = searchByCreatedDate ? 'created' : 'end';
				searchModel[`${searchBy}Before`] = before;
				searchModel[`${searchBy}After`] = after;
				return this.porticoService.enterpriseService.siteAccountService.searchWorkflows(searchModel);
			}, 'siteAccount_searchWorkflows');
		}

		////////////////////////////////
		// state transition functions //
		////////////////////////////////

		page(name: string, options: any = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.page(name, options);
			}, 'page');
		}

		section(name: string, options: any = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.section(name, options);
			}, 'section');
		}

		state(app: string, layout: string, page: string, intake: string = null, section: string = null, options: any = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.state(app, layout, page, intake, section, options);
			}, 'state');
		}

		//////////////////////
		// survey functions //
		//////////////////////

		survey_get(survey: number | string): ActionProcessor {
			return this._add(() => {
				const surveyId = this.porticoService.dataService.getEnvironmentId(survey);
				return this.porticoService.enterpriseService.surveyService.get(surveyId);
			}, 'survey_get');
		}

		/////////////////////////////
		// surveySession functions //
		/////////////////////////////

		surveySession_save(surveySession: pme.SurveySession): ActionProcessor {
			return this._add(() => {
				return this.porticoService.enterpriseService.surveyService.saveSurveySession(surveySession);
			}, 'surveySession_save');
		}


		//////////////////////
		// toastr functions //
		//////////////////////

		addToastr(type: string, title: string, content: string, options: any = null): ActionProcessor {
			return this._add(() => {
				return this.porticoService.toastrService.add(type, title, content, options);
			}, 'addToastr');
		}

		clearAllToastr(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.toastrService.clearAll();
			}, 'clearAllToastr');
		}

		removeLastToastr(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.toastrService.removeLast();
			}, 'clearAllToastr');
		}

		////////////////////
		// user functions //
		////////////////////

		user_create(): ActionProcessor {
			return this._add(() => {
				return this.porticoService.authenticationService.createUser();
			}, 'user_create');
		}
	}

	export interface IActionService {
		scope($scope?: angular.IScope): ActionProcessor;
	}

	@Service('app', 'actionService')
	@Inject('$q', 'porticoService')
	export class ActionService implements IActionService {
		constructor(private $q: angular.IQService, private porticoService: ps.IPorticoService) {
		}

		scope($scope: angular.IScope = null): ActionProcessor {
			return new ActionProcessor(this.$q, this.porticoService).scope($scope);
		}
	}
}